/**
 * Created by shadeeka on 4/20/19.
 */
import * as _ from 'lodash';
import * as am4core from '@amcharts/amcharts4/core';
import * as pako from 'pako';
import { XYChart } from '@amcharts/amcharts4/charts';
import * as am4charts from '@amcharts/amcharts4/charts';
import { AmChartDownloadService } from '../services/chart-download.services';

export class Util {
  public static uuidv4() {
    return Math.random().toString();
  }

  public static decode<T>(encodedData: unknown) {
    const byteArray = new Uint8Array(encodedData as any);
    const inflatedStr = pako.inflate(byteArray, { to: 'string' });
    return JSON.parse(inflatedStr) as T;
  }

  public static createTree(props: any[], dataSet: any[], numberProp) {
    const treeArr = [];
    const dataMap = {};
    if (props.length > 0) {
      for (let i = 0; i < props.length; i++) {
        const selectedItem = props[i];
        if (Object.keys(dataMap).length > 0) {
          this.createRoot(dataMap, selectedItem, treeArr, numberProp);
        } else {
          this.addToTree(dataMap, dataSet, selectedItem, treeArr, numberProp);
        }
      }
    }
    return treeArr;
  }

  public static isDifferent(obj1, obj2): boolean {
    return !_.isEqual(obj1, obj2);
  }

  private static createRoot(parent, value, treeArr, numberProp) {
    // this.logger.debug('Reading >> ' + value);

    for (const key in parent) {
      if (parent[key].hasOwnProperty('ch')) {
        const find = treeArr.find((item) => item.name === key);
        if (find) {
          find.children = []; // clear previous elements
          // this.logger.trace('tree-createroot-if' , key, treeArr);
          this.addToTree(parent[key], parent[key].ch, value, find.children, numberProp);
        }
      } else {
        const find = treeArr.find((item) => item.name === key);
        if (find) {
          // this.logger.trace('tree-createroot-else', key , treeArr);
          this.createRoot(parent[key], value, find.children, numberProp);
        }
      }
    }
  }

  private static addToTree(tree, arr, value, treeRoot, numberProp) {
    // console.log(value);
    arr.forEach((tmpl) => {
      if (tree.hasOwnProperty(tmpl[value])) {
        tree[tmpl[value]].ch.push(tmpl);
        tree[tmpl[value]].children.push({
          name: tmpl[value],
          count: tmpl[numberProp],
          children: [],
        });
        // find previously added child node and put it there
        const find = treeRoot.find((item) => item.name === tmpl[value]);
        if (find) {
          find.children.push({
            name: tmpl[value],
            children: [],
            count: tmpl[numberProp],
            data: tmpl,
          });
        }
      } else {
        tree[tmpl[value]] = {
          ch: [tmpl],
          children: [
            {
              name: tmpl[value],
              count: tmpl[numberProp],
              children: [],
              data: tmpl,
            },
          ],
        };
        treeRoot.push({
          name: tmpl[value],
          count: tmpl[numberProp],
          children: [],
          data: tmpl,
        });
      }
    });
    tree['ch'];
  }

  public static updateExport(_chartInstance, filters) {
    const title = _chartInstance.titles._values[0];
    if (title) {
      title.text = filters;
      title.marginBottom = 11;
    }
  }

  public static exportChart(
    downloadAmChart: AmChartDownloadService['downloadAmChart'],
    _chartInstance: XYChart,
    ctitle: string,
    date: string,
    exportContainerId: string | null,
    menuItems?: am4core.IExportMenuItem[],
  ) {
    const selectedFiltersTitle = _chartInstance.titles.create();
    selectedFiltersTitle.disabled = true;

    const title = _chartInstance.titles.create();
    title.text = date ? ctitle + ' (' + date + ')' : ctitle;
    title.marginBottom = 11;
    title.disabled = true;

    _chartInstance.exporting.menu = new am4core.ExportMenu();
    _chartInstance.exporting.events.on('exportfinished', (ev) => {
      downloadAmChart(_chartInstance.exporting.filePrefix, ev);
    });

    if (exportContainerId) {
      _chartInstance.exporting.menu.container = document.getElementById(
        exportContainerId,
      ) as am4core.Optional<HTMLElement>;
    } else {
      _chartInstance.exporting.menu.align = 'right';
      _chartInstance.exporting.menu.verticalAlign = 'top';
    }

    _chartInstance.exporting.menu.items = menuItems || [
      {
        label: '...',
        menu: [{ type: 'png', label: 'PNG' }],
      },
    ];

    _chartInstance.exporting.filePrefix = 'zf-' + ctitle.toLowerCase().split(' ').join('-');

    _chartInstance.exporting.events.on('exportstarted', (ev) => {
      title.disabled = false;
      selectedFiltersTitle.disabled = false;
    });
    // Disable title when export finishes
    _chartInstance.exporting.events.on('exportfinished', (ev) => {
      title.disabled = true;
      selectedFiltersTitle.disabled = true;
    });

    //Time in millis until the modal with timeout msg opens up
    //_chartInstance.exporting.timeoutDelay = 1000;

    _chartInstance.exporting.adapter.add('timeoutMessage', () => {
      return { message: 'Please wait while we prepare your file for download.' };
    });
  }

  static symmetricRound = (num: number) => {
    return Math.sign(num) * Math.round(Math.abs(num));
  };

  static responsiveChart = (chartInstance, breakpoint: number, barOrientation: boolean) => {
    chartInstance.responsive.enabled = true;
    chartInstance.responsive.useDefault = false;
    const scrollBar = new am4core.Scrollbar();
    scrollBar.minHeight = 7;
    scrollBar.disabled = true;

    const customizeGrip = (grip) => {
      grip.icon.disabled = true;
      grip.background.disabled = true;
      const img = grip.createChild(am4core.Circle);
      img.width = 18;
      img.height = 18;
      img.fill = am4core.color('#002566');
      img.align = 'center';
      img.valign = 'middle';
      img.fillOpacity = 0.7;
    };

    customizeGrip(scrollBar.startGrip);
    customizeGrip(scrollBar.endGrip);

    if (barOrientation === true) {
      chartInstance.scrollbarX = scrollBar;
    } else {
      chartInstance.scrollbarY = scrollBar;
    }

    chartInstance.responsive.rules.push({
      relevant: function (target) {
        if (target.pixelWidth <= breakpoint) {
          return true;
        }

        return false;
      },
      state: function (target, stateId) {
        if (target instanceof am4charts.Chart) {
          const state = target.states.create(stateId);
          state.properties.paddingTop = barOrientation ? 0 : 15;
          state.properties.paddingRight = 15;
          state.properties.paddingBottom = 5;
          state.properties.paddingLeft = 15;
          return state;
        }

        if (target instanceof am4charts.XYCursor) {
          const state = target.states.create(stateId);
          state.properties.disabled = true;
          return state;
        }

        if (target instanceof am4core.Scrollbar) {
          const state = target.states.create(stateId);
          state.properties.marginBottom = 15;
          state.properties.disabled = false;
          return state;
        }

        if (target instanceof am4charts.Legend) {
          const state = target.states.create(stateId);
          state.properties.paddingTop = 0;
          state.properties.paddingRight = 0;
          state.properties.paddingLeft = 0;
          state.properties.marginLeft = 0;
          return state;
        }

        if (target instanceof am4charts.AxisRendererY) {
          const state = target.states.create(stateId);
          state.properties.inside = true;
          state.properties.maxLabelPosition = 0.99;
          return state;
        }
        if (target instanceof am4charts.AxisLabel && target.parent instanceof am4charts.AxisRendererY) {
          const state = target.states.create(stateId);
          state.properties.fontSize = 10;

          // Create a separate state for background
          if (barOrientation) {
            target.setStateOnChildren = true;
            const bgstate = target.background.states.create(stateId);
            bgstate.properties.fill = am4core.color('#FAF9F6');
            bgstate.properties.fillOpacity = 0.8;
            bgstate.properties.paddingTop = 8;
            bgstate.properties.paddingLeft = 8;
            bgstate.properties.paddingRight = 8;
            bgstate.properties.paddingBottom = 8;
          }

          return state;
        }

        if (target instanceof am4charts.AxisLabel && target.parent instanceof am4charts.AxisRendererX) {
          const state = target.states.create(stateId);
          state.properties.fontSize = 10;

          return state;
        }

        if (target instanceof am4charts.LabelBullet) {
          const bulletState = target.label.states.create(stateId);
          bulletState.properties.dy = 7;
          return bulletState;
        }
        return null;
      },
    });
  };
}
